export const asCast = <T>(input: unknown, type: T): T => {
	return input as unknown as typeof type;
};
